export const sortCubeMapUrls = (urls) => {
    const order = ['px', 'nx', 'py', 'ny', 'pz', 'nz'];
    return order.map(face => {
      return urls.find(url => url.includes(`_${face}.`));
    });
  }